module.exports = __webpack_public_path__ + "img/result-contact-btn.b10eafae.png";